import VeriflytTab from "./veriflyt-tab";
export default VeriflytTab;